<template>
   <div class="modals-container">
      <component
         :is="modal.comp"
         v-for="modal in modalStackCopy"
         :key="modal.id"
         v-bind="modal.props"
         @confirm="modal.confirm"
         @cancel="modal.cancel"
      >
         <component
            v-if="modal.slot != null"
            :is="modal.slot.comp"
            v-bind="modal.slot.props"
         ></component>
      </component>
   </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';
import {gDialogService, type IDialogData} from './dialog_service';

interface ICompData {
   /** Copy of the service's dialog stack; the service itself is not reactive. */
   modalStackCopy: IDialogData<any>[];
}

export default defineComponent({
   data(): ICompData {
      return {
         modalStackCopy: [],
      };
   },

   mounted() {
      gDialogService.addCallback(() => {
         this.modalStackCopy = [...gDialogService.getStack()];
      });
   },

   methods: {
      //
   },
});
</script>
